import { CommonKeys } from "../../common/enums";
import { FormularGroup } from "./FormularGroup";

export interface FormularGroupDynamicFields extends FormularGroup {
    LayoutDefinitionID: string;
    Categories: FormularDynamicFieldsCategory[];
}

export interface FormularDynamicFieldsCategories {
    [CommonKeys.Type]: string;
    [CommonKeys.Values]: FormularDynamicFieldsCategory[];
}

export interface FormularDynamicFieldsCategory {
    [CommonKeys.Type]: string;
    ID: string;
    UniqueName: string;
    Label: string;
    Groups?: FormularDynamicFieldsGroups
    Fields?: FormularDynamicFields
}

export interface FormularDynamicFieldsGroups {
    [CommonKeys.Type]: string;
    [CommonKeys.Values]: FormularDynamicFieldsGroup[];
}

export interface FormularDynamicFieldsGroup {
    [CommonKeys.Type]: string;
    ID: number;
    UniqueName: string;
    Label: string;
    Fields: FormularDynamicFields
}

export interface FormularDynamicFields {
    [CommonKeys.Type]: string;
    [CommonKeys.Values]: FormularDynamicFieldsField[]
}

export interface FormularDynamicFieldsField {
    [CommonKeys.Type]: string;
    ID: number;
    UniqueName: string;
    Label: string;
    IsEyeCatching: boolean;
    DataType: FieldDataType;
    InputType: FieldInputType;
    Value?: string;
}

export enum FieldDataType {
    String,
    Int,
    Float,
    DateTime,
    Bool,
    Image,
    File
}

export enum FieldInputType {
    SingleLine = 1,
    MultiLine,
    Spin,
    CheckBox,
    SingleChoice,
    MultipleChoice,
    DatePicker,
    DateTimePicker,
    ComboExistingValues
}

// export type FieldDataType =
//     "String" |
//     "Int" |
//     "Float" |
//     "DateTime" |
//     "Bool" |
//     "Image" |
//     "File"

// export type FieldInputType =
//     "SingleLine" |
//     "MultiLine" |
//     "Spin" |
//     "CheckBox" |
//     "SingleChoice" |
//     "MultipleChoice" |
//     "DatePicker" |
//     "DateTimePicker" |
//     "ComboExistingValues"

// const VALID_DATA_TYPES: readonly FieldDataType[] = [
//     "String",
//     "Int",
//     "Float",
//     "DateTime",
//     "Bool",
//     "Image",
//     "File"
// ];

// const VALID_INPUT_TYPES: readonly FieldInputType[] = [
//     "SingleLine",
//     "MultiLine",
//     "Spin",
//     "CheckBox",
//     "SingleChoice",
//     "MultipleChoice",
//     "DatePicker",
//     "DateTimePicker",
//     "ComboExistingValues"
// ];